import { Injectable } from '@angular/core';
import { GetLoyaltyActiveCollectionsResponseDto } from '@src/api';
import { BaseStoreService } from '@src/app/modules/base';

@Injectable({
  providedIn: 'root',
})
export class LpActiveCollectionsStoreService extends BaseStoreService<GetLoyaltyActiveCollectionsResponseDto[]> {}
